export enum DrawingType {
  EP = 'EP',
  BMP = 'BMP',
  TFT = 'TFT',
  PATHLABEL = 'PATHLABEL',
  NON_PRODUCTION_ITEM = 'NON_PRODUCTION_ITEM',
  PVD = 'PVD',
  MANUAL_NON_PRODUCTION_ITEM = 'MANUAL_NON_PRODUCTION_ITEM'
}
